import React, { useState } from 'react';
import { Grid, Layout, theme } from 'antd';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import ProtectedRoute from '../ProtectedRoute';

const { Content } = Layout;
const { useBreakpoint } = Grid;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const screens = useBreakpoint();
  const location = useLocation();
  const isMobile = !screens.lg;
  const { token } = theme.useToken();

  React.useEffect(() => {
    if (isMobile) setCollapsed(true);
  }, [isMobile]);

  React.useEffect(() => {
    if (isMobile) setCollapsed(true);
  }, [location.pathname, isMobile]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar collapsed={collapsed} isMobile={isMobile} onNavigate={() => isMobile && setCollapsed(true)} />
      <Layout
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 80 : 250,
          transition: 'margin-left 0.2s',
        }}
      >
        {isMobile && !collapsed ? (
          <div
            onClick={() => setCollapsed(true)}
            aria-hidden
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.35)',
              zIndex: 1001,
            }}
          />
        ) : null}
        <Header collapsed={collapsed} setCollapsed={setCollapsed} isMobile={isMobile} />
        <Content
          style={{
            margin: isMobile ? '8px 0 0' : '24px 16px',
            padding: isMobile ? '0 8px 16px' : 24,
            background: token.colorBgLayout,
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          <div
            style={{
              background: token.colorBgContainer,
              borderRadius: isMobile ? token.borderRadius : token.borderRadiusLG,
              padding: isMobile ? 12 : 20,
              boxShadow: isMobile ? 'none' : '0 10px 30px rgba(16,24,40,0.06)',
              minHeight: '100%',
            }}
          >
            <ProtectedRoute>{children}</ProtectedRoute>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
